import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import InvoiageApp from "./InvoiageApp"
import reportWebVitals from './reportWebVitals';

const Component = process.env.REACT_APP_MODE === 'invoiage' ? InvoiageApp : App;

ReactDOM.render(
  <React.StrictMode>
    <Component />
  </React.StrictMode>,
  document.getElementById('root')
);

// Dynamically set favicon and related icons
const isInvoiage = process.env.REACT_APP_MODE === 'invoiage';
const basePath = isInvoiage ? '/invoiage_assets' : '';

// Update favicon
const favicon = document.querySelector("link[rel*='icon'][href*='favicon.ico']") || document.createElement('link');
favicon.rel = 'icon';
favicon.href = `${basePath}/favicon.ico`;
document.head.appendChild(favicon);

// Update apple-touch-icon
const appleIcon = document.querySelector("link[rel='apple-touch-icon']") || document.createElement('link');
appleIcon.rel = 'apple-touch-icon';
appleIcon.sizes = '180x180';
appleIcon.href = `${basePath}/apple-touch-icon.png`;
document.head.appendChild(appleIcon);

// Update favicon-32x32
const favicon32 = document.querySelector("link[rel*='icon'][sizes='32x32']") || document.createElement('link');
favicon32.rel = 'icon';
favicon32.type = 'image/png';
favicon32.sizes = '32x32';
favicon32.href = `${basePath}/favicon-32x32.png`;
document.head.appendChild(favicon32);

// Update favicon-16x16
const favicon16 = document.querySelector("link[rel*='icon'][sizes='16x16']") || document.createElement('link');
favicon16.rel = 'icon';
favicon16.type = 'image/png';
favicon16.sizes = '16x16';
favicon16.href = `${basePath}/favicon-16x16.png`;
document.head.appendChild(favicon16);

// Update manifest
const manifest = document.querySelector("link[rel='manifest']") || document.createElement('link');
manifest.rel = 'manifest';
manifest.href = `${basePath}/site.webmanifest`;
document.head.appendChild(manifest);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
